<ngx-app-bar
  class="w-100"
  [title]="'پروفایل مدیریت ثروت'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="container">
  <!-- ? user info -->
  @if (user?.nationalId) {
    <div class="section-container">
      <div class="section-container-header">
        <h2 class="title mb-small">مشخصات</h2>
      </div>
      <app-user-info-card
        class="w-100"
        [user]="user"
      />
    </div>
  }

  <!-- ? Bank account info -->
  @if (user?.bankAccounts?.length > 0) {
    <div class="section-container">
      <h2 class="title mb-small">اطلاعات حساب بانکی</h2>
      @for (account of user?.bankAccounts; track $index) {
        @if (account.isDefault) {
          <app-user-bank-card
            class="w-100"
            [bankAccountData]="account"
          />
        }
      }
    </div>
  }

  <!-- ? User Access -->
  <div class="section-container">
    <div class="section-container-header">
      <h2 class="title mb-small">مدیریت حساب سرمایه‌گذاری</h2>
    </div>

    <div class="access-container">
      @for (manage of manageItems; track manage) {
        @if (manage.active) {
          <div
            class="item"
            (click)="goto(manage.route)"
          >
            <div class="title">
              <img
                [src]="manage.icon"
                [alt]="manage.title"
              />
              {{ manage.title }}
            </div>
            <div class="icon">
              <ngx-icon name="arrow-2-left"></ngx-icon>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div class="buttons-container">
    @if (user.isSejami) {
      <ngx-button
        [style]="'tinted-on-back'"
        size="medium"
        [mode]="'form'"
        [fullWidth]="true"
        [isLoading]="loadingSejami"
        (clickHandler)="updateSejam()"
        [disabled]="sejamRateLimit"
      >
        @if (sejamRateLimit || !timeIsOver) {
          <ngx-count-down
            [timeInSeconds]="limitTime"
            [type]="'mm:ss'"
            (finished)="timerFinish()"
          ></ngx-count-down>
          <span> تلاش دوباره </span>
        } @else {
          به روز رسانی اطلاعات سجام
        }
      </ngx-button>
    }

    <ngx-button
      [destructive]="true"
      [style]="'tinted-on-back'"
      size="medium"
      [mode]="'form'"
      [fullWidth]="true"
      (clickHandler)="logout()"
    >
      خروج
    </ngx-button>
  </div>
</div>
